import { render, staticRenderFns } from "./ProjectMediaMention.vue?vue&type=template&id=12199fcc&"
import script from "./ProjectMediaMention.vue?vue&type=script&lang=js&"
export * from "./ProjectMediaMention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports